"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _api = require("@focaltec-suite/api");
var _core = require("@focaltec-suite/core");
var _UserAccessForm = _interopRequireDefault(require("./UserAccessForm"));
var _UserEmailPopup = require("./UserEmailPopup");
var _extended_fields = require("../extended_fields");
var _UserAdditionalEmails = _interopRequireDefault(require("./UserAdditionalEmails"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function UserForm(_ref) {
  var _this = this;
  var userId = _ref.userId,
    tenantId = _ref.tenantId,
    defaultRoles = _ref.defaultRoles,
    redirectAfter = _ref.redirectAfter;
  var history = (0, _reactRouterDom.useHistory)();
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var _useState = (0, _react.useState)(userId ? 'read_only' : 'email'),
    _useState2 = _slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var validators = (0, _react.useMemo)(function () {
    return [new _commons.PhoneValidator()];
  }, []);
  var languages = (0, _react.useMemo)(function () {
    return _api.LANGUAGES.map(function (lang) {
      return {
        value: lang,
        label: (0, _core.translate)("users.language.".concat(lang))
      };
    });
  }, []);
  var accessTypes = (0, _react.useMemo)(function () {
    return ['owner', 'tenant'].map(function (el) {
      return {
        value: el,
        label: (0, _core.translate)("roles.types.".concat(el))
      };
    });
  }, []);
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    isValid = _useValidatedForm.isValid,
    bind = _useValidatedForm.bind,
    register = _useValidatedForm.register,
    registerInner = _useValidatedForm.registerInner,
    isDirty = _useValidatedForm.isDirty,
    setPristine = _useValidatedForm.setPristine;
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    accessType = _useState4[0],
    setAccessType = _useState4[1];
  var _useState5 = (0, _react.useState)({
      policies: []
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    userAccess = _useState6[0],
    setUserAccess = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    additionalEmails = _useState8[0],
    setAdditionalEmails = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    user = _useState10[0],
    setUser = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = _slicedToArray(_useState11, 2),
    metadata = _useState12[0],
    setMetadata = _useState12[1];
  var _useState13 = (0, _react.useState)(),
    _useState14 = _slicedToArray(_useState13, 2),
    company = _useState14[0],
    setCompany = _useState14[1];
  var _useState15 = (0, _react.useState)(),
    _useState16 = _slicedToArray(_useState15, 2),
    companies = _useState16[0],
    setCompanies = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    hasCompaniesWithoutRoles = _useState18[0],
    setHasCompaniesWithoutRoles = _useState18[1];
  var _useState19 = (0, _react.useState)([]),
    _useState20 = _slicedToArray(_useState19, 2),
    roleOptions = _useState20[0],
    setRoleOptions = _useState20[1];
  var _useState21 = (0, _react.useState)(''),
    _useState22 = _slicedToArray(_useState21, 2),
    format = _useState22[0],
    setFormat = _useState22[1];
  var _useState23 = (0, _react.useState)(),
    _useState24 = _slicedToArray(_useState23, 2),
    extendedFields = _useState24[0],
    setExtendedFields = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = _slicedToArray(_useState25, 2),
    emailPopup = _useState26[0],
    setEmailPopup = _useState26[1];
  var _useState27 = (0, _react.useState)(),
    _useState28 = _slicedToArray(_useState27, 2),
    roleId = _useState28[0],
    setRoleId = _useState28[1];
  var showAccessType = (0, _react.useMemo)(function () {
    return tenantId && formState !== 'email';
  }, [tenantId, formState]);
  var showCompanyAccesses = (0, _react.useMemo)(function () {
    return tenantId && accessType === 'tenant' && formState !== 'email';
  }, [tenantId, accessType, formState]);
  var showRole = (0, _react.useMemo)(function () {
    return !tenantId && formState !== 'email';
  }, [tenantId, formState]);
  var retrievePromise = (0, _react.useCallback)(function () {
    if (userId) {
      return (0, _api.getUser)(userId, {
        includeAccesses: true
      }, {
        tenantId: tenantId,
        access: access
      });
    }
    return (0, _api.emptyPromise)();
  }, [tenantId, userId, access]);
  var metadataPromise = (0, _react.useCallback)(function () {
    return (0, _api.getMetadata)({}, {
      tenantId: tenantId,
      access: access
    });
  }, [tenantId, access]);
  var listPromise = (0, _react.useCallback)(function (email) {
    return (0, _api.findUser)(email, {
      tenantId: tenantId,
      access: access
    });
  }, [tenantId, access]);
  var companiesPromise = (0, _react.useCallback)(function () {
    if (tenantId) {
      return (0, _api.listCompanies)(tenantId, {
        page: 0,
        offset: 0,
        search: ''
      }, {
        access: access
      });
    }
    return (0, _api.emptyPromise)();
  }, [tenantId, access]);
  var extendedFieldsPromise = (0, _react.useCallback)(function () {
    if (tenantId) {
      var params = {
        search: '',
        page: 0,
        offset: 0,
        familyIds: ['users']
      };
      return (0, _api.listExtendedFields)(tenantId, params, {
        access: access
      });
    }
    return (0, _api.emptyPromise)();
  }, [tenantId, access]);
  var getAccessAsRequest = (0, _react.useCallback)(function (user) {
    var _a;
    var userAccess = user === null || user === void 0 ? void 0 : user.access;
    return {
      id: userAccess === null || userAccess === void 0 ? void 0 : userAccess.id,
      type: userAccess === null || userAccess === void 0 ? void 0 : userAccess.type,
      policies: (_a = userAccess === null || userAccess === void 0 ? void 0 : userAccess.policies.map(function (policy) {
        return {
          company_id: policy.company_id,
          role_ids: policy.role_ids
        };
      })) !== null && _a !== void 0 ? _a : []
    };
  }, []);
  var fetchData = (0, _react.useCallback)(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var user, metadata, companies, extendedFields;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return retrievePromise();
          case 2:
            user = _context.sent;
            _context.next = 5;
            return metadataPromise();
          case 5:
            metadata = _context.sent;
            _context.next = 8;
            return companiesPromise();
          case 8:
            companies = _context.sent;
            _context.next = 11;
            return extendedFieldsPromise();
          case 11:
            extendedFields = _context.sent;
            return _context.abrupt("return", [user, metadata, companies, extendedFields]);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [retrievePromise, metadataPromise, companiesPromise, extendedFieldsPromise]);
  var setData = (0, _react.useCallback)(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 4),
      user = _ref3[0],
      metadata = _ref3[1],
      companies = _ref3[2],
      extendedFields = _ref3[3];
    var _a, _b, _c;
    setUser(user);
    setAdditionalEmails((_a = user === null || user === void 0 ? void 0 : user.additional_emails) !== null && _a !== void 0 ? _a : []);
    var access = getAccessAsRequest(user);
    setUserAccess(access);
    setAccessType(access.type);
    if (access.policies.length) {
      setRoleId(access.policies[0].role_ids[0]);
    }
    if (user) {
      setFormState(user.status === 'active' ? 'read_only' : 'open');
    }
    setMetadata(metadata);
    setRoleOptions(metadata.roles.map(function (role) {
      return {
        value: role.id,
        label: role.name
      };
    }));
    var newCompanies = companies === null || companies === void 0 ? void 0 : companies.items.map(function (el) {
      var _a, _b, _c;
      var map = {};
      (_c = (_b = (_a = access.policies) === null || _a === void 0 ? void 0 : _a.filter(function (policy) {
        return policy.company_id === el.id;
      })) === null || _b === void 0 ? void 0 : _b.flatMap(function (policy) {
        return policy.role_ids;
      })) === null || _c === void 0 ? void 0 : _c.forEach(function (roleId) {
        map[roleId] = true;
      });
      return Object.assign(Object.assign({}, el), {
        roles: Object.keys(map).length
      });
    });
    var companiesWithRoles = (_c = (_b = newCompanies === null || newCompanies === void 0 ? void 0 : newCompanies.filter(function (el) {
      return el.roles > 0;
    })) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
    setCompanies(newCompanies);
    setHasCompaniesWithoutRoles(companiesWithRoles === 0);
    setExtendedFields(extendedFields === null || extendedFields === void 0 ? void 0 : extendedFields.items);
  }, [getAccessAsRequest]);
  var hasChangedPhone = (0, _react.useCallback)(function (name, value) {
    var newFormat = (0, _commons.phoneFormat)(value ? value : '');
    if (format !== newFormat) {
      setFormat(newFormat);
    }
  }, [format]);
  var submitPromise = function submitPromise() {
    var _a = bind(),
      rawExtendedFields = _a.extended_fields,
      other = __rest(_a, ["extended_fields"]);
    var parsedExtendedFields = (0, _extended_fields.mapToRequest)(rawExtendedFields, extendedFields !== null && extendedFields !== void 0 ? extendedFields : []);
    var accessRequest = userAccess;
    if (!tenantId && roleId) {
      accessRequest = Object.assign(Object.assign({}, accessRequest), {
        type: 'platform',
        policies: [{
          role_ids: [roleId]
        }]
      });
    }
    var request = Object.assign(Object.assign({}, other), {
      access: accessRequest,
      additional_emails: additionalEmails,
      extended_fields: parsedExtendedFields
    });
    if (userId) {
      return (0, _api.updateUser)(userId, request, {
        tenantId: tenantId,
        access: access
      });
    }
    return (0, _api.createUser)(request, {
      tenantId: tenantId,
      access: access
    });
  };
  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    if (!isValid()) return;
    feedbackContext.showBackdrop();
    submitPromise().then(function (response) {
      setPristine();
      if (redirectAfter) {
        redirectAfter(response);
      } else {
        history.goBack();
      }
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  };
  var hasChangeAccessType = (0, _react.useCallback)(function (name, value) {
    var accessType = value ? value : undefined;
    if ((userAccess === null || userAccess === void 0 ? void 0 : userAccess.type) === accessType) {
      return;
    }
    var initialAccess = getAccessAsRequest(user);
    if ((initialAccess === null || initialAccess === void 0 ? void 0 : initialAccess.type) !== accessType) {
      var policies;
      if (accessType === 'tenant') {
        policies = [];
      } else {
        policies = [{
          role_ids: [tenantId ? 'owner' : 'admin']
        }];
      }
      initialAccess = {
        id: initialAccess === null || initialAccess === void 0 ? void 0 : initialAccess.id,
        type: accessType,
        policies: policies
      };
    }
    setUserAccess(initialAccess);
    setAccessType(accessType);
  }, [tenantId, userAccess, user, getAccessAsRequest]);
  var configureCompany = (0, _react.useCallback)(function (company, index) {
    return function () {
      setCompany(company);
    };
  }, []);
  var onUpdatedCompany = (0, _react.useCallback)(function (policy) {
    var _a, _b;
    if (!userAccess) return;
    var currentCompany = userAccess.policies.find(function (el) {
      return el.company_id === policy.company_id;
    });
    var policies;
    if (currentCompany) {
      policies = userAccess.policies.map(function (el) {
        if (el.company_id === policy.company_id) {
          return policy;
        }
        return el;
      });
    } else {
      policies = [].concat(_toConsumableArray(userAccess.policies), [policy]);
    }
    var newCompanies = companies === null || companies === void 0 ? void 0 : companies.map(function (company) {
      if (company.id === policy.company_id) {
        return Object.assign(Object.assign({}, company), {
          roles: policy.role_ids.length
        });
      }
      return company;
    });
    setUserAccess(function (curr) {
      return Object.assign(Object.assign({}, curr), {
        policies: policies
      });
    });
    var companiesWithRoles = (_b = (_a = newCompanies === null || newCompanies === void 0 ? void 0 : newCompanies.filter(function (el) {
      return el.roles > 0;
    })) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    setHasCompaniesWithoutRoles(companiesWithRoles === 0);
    setCompanies(newCompanies);
    setCompany(undefined);
  }, [userAccess, companies]);
  var hasChangedRole = (0, _react.useCallback)(function (name, value) {
    setRoleId(value ? value : undefined);
  }, []);
  var onSearch = (0, _react.useCallback)(function () {
    var raw = bind();
    if (!raw.email) {
      return;
    }
    if (!_commons.EMAIL_REGEX.test(raw.email)) {
      return;
    }
    if (user && user.email === raw.email) {
      setFormState('open');
      return;
    }
    feedbackContext.showBackdrop();
    listPromise(raw.email).then(function (user) {
      setUser(user);
      setFormState('read_only');
    })["catch"](function (error) {
      if (error instanceof _api.CustomError) {
        switch (error.apiError.code) {
          case 1300:
            setFormState('open');
            feedbackContext.showInfo((0, _core.translate)('users.no_results', {
              email: raw.email
            }));
            break;
          case 1303:
            feedbackContext.showWarning(error.message);
            break;
          default:
            feedbackContext.showError(error);
        }
      } else {
        feedbackContext.showError(error);
      }
    })["finally"](feedbackContext.closeBackdrop);
  }, [bind, listPromise, user, feedbackContext]);
  var onCancelEmail = (0, _react.useCallback)(function () {
    setFormState('email');
  }, []);
  var onAddedEmail = (0, _react.useCallback)(function (email) {
    var _bind = bind(),
      currentEmail = _bind.email;
    if (currentEmail === email || additionalEmails.indexOf(email) >= 0) {
      feedbackContext.showWarning((0, _core.translate)('users.additional_emails.duplicated', {
        email: email
      }));
    } else {
      setAdditionalEmails([].concat(_toConsumableArray(additionalEmails), [email]));
    }
  }, [bind, feedbackContext, additionalEmails]);
  var onDeletedEmail = (0, _react.useCallback)(function (index) {
    return function () {
      setAdditionalEmails(function (curr) {
        return curr.filter(function (el, i) {
          return i !== index;
        });
      });
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_commons.Retrievable, {
    getPromise: fetchData,
    setData: setData,
    builder: function builder() {
      var _a, _b, _c;
      return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        lg: 8,
        xl: 6
      }, /*#__PURE__*/_react["default"].createElement(_commons.Surface, {
        title: (0, _core.translate)(userId ? 'users.edit_user' : 'users.new_user'),
        subtitle: (_a = metadata === null || metadata === void 0 ? void 0 : metadata.tenant) === null || _a === void 0 ? void 0 : _a.name,
        icon: /*#__PURE__*/_react["default"].createElement(_commons.UserIcon, null)
      }, /*#__PURE__*/_react["default"].createElement("form", {
        autoComplete: "off",
        noValidate: true,
        onSubmit: onSubmit
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "space-between",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        spacing: 1
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        sm: formState === 'email' || formState === 'open' ? true : 12
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
        type: "email",
        name: "email",
        initialValue: user === null || user === void 0 ? void 0 : user.email,
        label: (0, _core.translate)('users.email'),
        required: true,
        disabled: formState === 'read_only' || formState === 'open',
        register: register
      })), formState === 'email' && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: "auto"
      }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "text",
        size: "small",
        color: "secondary",
        onClick: onSearch,
        sx: {
          ml: 1
        }
      }, (0, _core.translate)('buttons.continue'))), formState === 'open' && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        md: "auto"
      }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "text",
        size: "small",
        color: "secondary",
        onClick: onCancelEmail,
        sx: {
          ml: 1
        }
      }, (0, _core.translate)('users.change_email')))), formState === 'email' && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_material.Divider, {
        sx: {
          mt: 2
        }
      })))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "space-between",
        alignItems: "center",
        spacing: {
          xs: 0,
          md: 2
        },
        sx: formState === 'email' ? {
          display: 'none'
        } : undefined
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        md: 6
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
        type: "text",
        name: "first_name",
        initialValue: user === null || user === void 0 ? void 0 : user.first_name,
        label: (0, _core.translate)('users.first_name'),
        required: true,
        register: register
      })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        md: 6
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
        type: "text",
        name: "last_name",
        initialValue: user === null || user === void 0 ? void 0 : user.last_name,
        label: (0, _core.translate)('users.last_name'),
        required: true,
        register: register
      }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "space-between",
        alignItems: "center",
        spacing: {
          xs: 0,
          md: 2
        },
        sx: formState === 'email' ? {
          display: 'none'
        } : undefined
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        md: 6
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyMaskedInput, {
        name: "phone",
        initialValue: user === null || user === void 0 ? void 0 : user.phone,
        label: (0, _core.translate)('users.phone'),
        validators: validators,
        format: format,
        mask: " ",
        register: register,
        notifier: hasChangedPhone
      })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        md: 6
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyAutocomplete, {
        name: "language",
        label: (0, _core.translate)('users.language.title'),
        initialValue: (_b = user === null || user === void 0 ? void 0 : user.language) !== null && _b !== void 0 ? _b : 'es',
        options: languages,
        register: register,
        required: true
      }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "space-between",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        sx: {
          mt: 3,
          display: showAccessType ? 'block' : 'none'
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        variant: "body1"
      }, (0, _core.translate)('users.access')), /*#__PURE__*/_react["default"].createElement(_commons.AnyAutocomplete, {
        name: "access_type",
        label: (0, _core.translate)('roles.types.title'),
        initialValue: accessType,
        options: accessTypes,
        required: !!tenantId,
        register: register,
        notifier: hasChangeAccessType
      })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        sx: {
          mt: 1,
          display: showCompanyAccesses ? 'block' : 'none'
        }
      }, hasCompaniesWithoutRoles && /*#__PURE__*/_react["default"].createElement(_commons.Alert, {
        variant: "info",
        title: (0, _core.translate)('users.without_roles.title'),
        subheader: (0, _core.translate)('users.without_roles.subheader'),
        margin: 1.5,
        plain: true
      }), /*#__PURE__*/_react["default"].createElement(_material.Card, {
        variant: "outlined"
      }, /*#__PURE__*/_react["default"].createElement(_commons.Griddable, {
        items: companies !== null && companies !== void 0 ? companies : [],
        loading: false,
        empty: (0, _core.translate)('companies.empty'),
        getId: function getId(company) {
          return company.id;
        },
        hoverable: false,
        noBorderLastRow: true,
        columns: [{
          title: (0, _core.translate)('companies.single'),
          converter: function converter(company) {
            return company.name;
          },
          id: 'company',
          xs: true
        }, {
          title: (0, _core.translate)('roles.title'),
          converter: function converter(company) {
            return company.roles;
          },
          id: 'role',
          textAlign: 'center',
          xs: 4,
          sm: 4,
          md: 3,
          lg: 3,
          xl: 2
        }, {
          title: /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
            color: "primary",
            size: "small",
            sx: {
              visibility: 'hidden'
            }
          }, /*#__PURE__*/_react["default"].createElement(_commons.SettingsIcon, null)),
          converter: function converter(company, index, indexRow) {
            return /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
              color: "primary",
              size: "small",
              onClick: configureCompany(company, indexRow)
            }, /*#__PURE__*/_react["default"].createElement(_commons.SettingsIcon, null));
          },
          id: 'actions',
          textAlign: 'center',
          xs: 'auto'
        }]
      }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        sx: {
          display: showRole ? 'block' : 'none'
        }
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyAutocomplete, {
        name: "role_id",
        label: (0, _core.translate)('roles.single'),
        initialValue: roleId,
        options: roleOptions,
        required: !tenantId,
        register: register,
        notifier: hasChangedRole
      })), /*#__PURE__*/_react["default"].createElement(_UserAdditionalEmails["default"], {
        tenantId: tenantId,
        hidden: formState === 'email',
        additionalEmails: additionalEmails,
        onAddedEmail: onAddedEmail,
        onDeletedEmail: onDeletedEmail
      }), extendedFields && extendedFields.length > 0 && formState !== 'email' && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        sx: {
          mt: 3
        }
      }, /*#__PURE__*/_react["default"].createElement(_extended_fields.ExtendedFieldsFormSection, {
        tenantId: tenantId,
        access: access,
        current: (_c = user === null || user === void 0 ? void 0 : user.extended_fields) !== null && _c !== void 0 ? _c : {},
        extendedFields: extendedFields,
        registerInner: registerInner
      })), /*#__PURE__*/_react["default"].createElement(_commons.FormActions, {
        id: userId,
        disabled: formState === 'email' || accessType === 'tenant' && hasCompaniesWithoutRoles
      })), /*#__PURE__*/_react["default"].createElement(_commons.FormPrompt, {
        isDirty: isDirty
      }))))), company && userAccess && /*#__PURE__*/_react["default"].createElement(_UserAccessForm["default"], {
        tenantId: tenantId !== null && tenantId !== void 0 ? tenantId : '-',
        company: company,
        policies: userAccess.policies,
        defaultRoles: defaultRoles,
        onUpdated: onUpdatedCompany,
        onClose: function onClose() {
          return setCompany(undefined);
        }
      }), emailPopup && /*#__PURE__*/_react["default"].createElement(_UserEmailPopup.UserEmailPopup, {
        onAdd: onAddedEmail,
        onClose: function onClose() {
          return setEmailPopup(false);
        }
      }));
    }
  });
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(UserForm);